module.exports = __webpack_public_path__ + "img/01_uk.dd4ff10c.svg";